import { ConsentContext } from "../user-consent-management";
import { useRouter } from "next/router";
import React from "react";
import Script from "next/script";
export const GoogleAnalyticsContext = React.createContext({});
GoogleAnalyticsContext.displayName = "GoogleAnalyticsContext";
export const GoogleAnalytics = ({ children, debug = false, grantId = "google-analytics", gtag, trackingId, }) => {
    const consentContext = React.useContext(ConsentContext);
    if (!consentContext)
        throw new Error("GoogleAnalytics provider must be used inside a ConsentProvider");
    const { hasGrant } = consentContext;
    const grant = React.useMemo(() => ({ id: grantId }), [grantId]);
    const [hasAnalyticsGrant, setHasAnalyticsGrant] = React.useState(false);
    const router = useRouter();
    const isProductionEnv = process.env.NODE_ENV && process.env.NODE_ENV !== "development";
    const trackPageview = React.useCallback((url) => {
        if (!hasAnalyticsGrant)
            return;
        if (!isProductionEnv && !debug)
            return;
        const track = gtag ?? window.gtag;
        track("config", trackingId, {
            page_path: url,
        });
    }, [debug, gtag, trackingId, hasAnalyticsGrant, isProductionEnv]);
    const trackEvent = React.useCallback((action, payload = {}) => {
        if (!hasAnalyticsGrant)
            return;
        if (!isProductionEnv && !debug)
            return;
        const track = gtag ?? window.gtag;
        track("event", action, payload);
    }, [debug, gtag, hasAnalyticsGrant, isProductionEnv]);
    React.useEffect(() => {
        setHasAnalyticsGrant(hasGrant(grant));
    }, [grant, hasGrant]);
    //   automatically track page views
    React.useEffect(() => {
        router.events.on("routeChangeComplete", trackPageview);
        return () => {
            router.events.off("routeChangeComplete", trackPageview);
        };
    }, [router.events, hasAnalyticsGrant, trackPageview]);
    if (!trackingId)
        console.warn("Expected process.env.GA_TRACKING_ID to be set");
    return (React.createElement(React.Fragment, null,
        hasAnalyticsGrant && !gtag && (React.createElement(React.Fragment, null,
            React.createElement(Script, { strategy: "afterInteractive", src: `https://www.googletagmanager.com/gtag/js?id=${trackingId}` }),
            React.createElement(Script, { id: "google-analytics", strategy: "afterInteractive", dangerouslySetInnerHTML: {
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingId}', {
              page_path: window.location.pathname,
              ${debug ? "'debug_mode':true" : ""}
            });
          `,
                } }))),
        React.createElement(GoogleAnalyticsContext.Provider, { value: { trackEvent } }, children)));
};
//# sourceMappingURL=google-analytics.js.map